import React, { useState } from 'react'
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const CreateModuleComp = (props) => {

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [module, setModule] = useState('')
    const [path, setPath] = useState('')

    const handleCreate = () => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            namaModule: module,
            pathModule: path,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: '/modules/create',
            method: 'POST',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Successfully created Module!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.close()
                    props.fetch()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: getApiErrorMessage(err)
                    })
                }
            })
    }

    return (
        <div>
            <div className="mb-3 row">
                <label htmlFor="module" className="col-sm-2 col-form-label">Modul</label>
                <div className="col-12">
                    <input type="text" className="form-control" id="module" onChange={(e) => setModule(e.target.value)} value={module} />
                </div>
            </div>
            <div className="mb-3 row">
                <label htmlFor="path" className="col-sm-2 col-form-label">Path</label>
                <div className="col-12">
                    <input type="text" className="form-control" id="path" onChange={(e) => setPath(e.target.value)} value={path} />
                </div>
            </div>
            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleCreate()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </div>
    )
}

export default CreateModuleComp
